import React, { Component } from 'react';
import {
    Box,
    withStyles
} from '@material-ui/core';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import CardSection from "../../shared/components/common/cardSection";
import RespondClienteSection from "../../shared/components/estimateRespond/respondClienteSection";
import RespondEstimateItemsSection from "../../shared/components/estimateRespond/respondEstimateItemsSection";
import RespondFormSection from "../../shared/components/estimateRespond/respondFormSection";
import RespondServicosModal from "../../shared/components/estimateRespond/respondServicosModal";

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
        padding: '1rem'
    },
});

class AdminEstimateRespondPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cliente: null,
            estimativaAtual: null,
            servicosCache: [],
            sections: {
                cliente: true,
                estimativa: true,
                resposta: true
            },
            modalServicosAberto: false,
            respostaData: {
                textoResposta: '',
                valorTotal: 0,
                itensResposta: []
            }
        };
    }

    componentDidMount() {
        this.initResponderEstimativa();
    }

    mockData = () => {
        const mockCliente = {
            empresa: "Empresa Teste Ltda",
            nome: "João Silva",
            telefone: "(11) 99999-9999",
            cnpj: "12.345.678/0001-90",
            dt_criacao: new Date().toISOString(),
            email: "joao@empresa.com"
        };

        const mockEstimativa = {
            id: 12345,
            itens: [
                {
                    servico_id: 1,
                    servico: "Manutenção Preventiva",
                    obs: "Troca de peças de desgaste"
                },
                {
                    servico_id: 2,
                    servico: "Calibração de Precisão",
                    obs: "Ajuste fino"
                }
            ]
        };

        const mockServicosCache = [
            {
                id: 1,
                codigo_interno: "CT001",
                nome: "Troca de Rolamento",
                tipo: "Peça",
                valor: 150.00,
                valor_2: 120.00,
                descricao: "Rolamento axial de alta precisão"
            },
            {
                id: 2,
                codigo_interno: "CT002",
                nome: "Mão de Obra Especializada",
                tipo: "Procedimento",
                valor: 300.00,
                valor_2: 250.00,
                descricao: "Serviço técnico especializado"
            }
        ];

        this.setState({
            cliente: mockCliente,
            estimativaAtual: mockEstimativa,
            servicosCache: mockServicosCache
        });
    };

    initResponderEstimativa = () => {
        this.mockData();
    };

    toggleSection = (section) => {
        this.setState(prevState => ({
            sections: {
                ...prevState.sections,
                [section]: !prevState.sections[section]
            }
        }));
    };

    abrirModalServicos = () => {
        this.setState({ modalServicosAberto: true });
    };

    fecharModalServicos = () => {
        this.setState({ modalServicosAberto: false });
    };

    handleRespostaChange = (respostaData) => {
        this.setState({ respostaData });
    };

    enviarResposta = async (textoResposta, valorTotal) => {
        const { estimativaAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!textoResposta.trim()) {
            Swal.fire(currentLanguage.bepiService.admin.admin_estimate_respond_swal_attention_title, currentLanguage.bepiService.admin.admin_estimate_respond_swal_no_items_text, "warning");
            return;
        }

        try {
            console.log('Enviando resposta:', {
                estimativaId: estimativaAtual?.id,
                textoResposta: textoResposta + "\n\n" + currentLanguage.bepiService.admin.admin_estimate_respond_created_by_admin,
                valorTotal: valorTotal.toFixed(2)
            });

            Swal.fire(currentLanguage.bepiService.admin.admin_estimate_respond_swal_success_title, currentLanguage.bepiService.admin.admin_estimate_respond_swal_sent_text, "success");

        } catch (error) {
            console.error("Erro ao enviar resposta:", error);
            Swal.fire(currentLanguage.bepiService.admin.admin_estimate_respond_swal_error_title, currentLanguage.bepiService.admin.admin_estimate_respond_swal_error_text, "error");
        }
    };

    adicionarItemResposta = (novoItem) => {
        if (this.respondFormRef) {
            this.respondFormRef.adicionarItem(novoItem);
        }
    };

    render() {
        const { sections, cliente, estimativaAtual, servicosCache, modalServicosAberto, respostaData } = this.state;
        const { classes } = this.props;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            // { label: currentLanguage.bepiService.admin.admin_breadcrumb_quotations, path: '/bepi/admin/quotations' },
            { label: currentLanguage.bepiService.admin.admin_breadcrumb_estimate_respond },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.admin.admin_breadcrumb_estimate_respond}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    <CardSection
                        title={currentLanguage.bepiService.admin.admin_estimate_respond_card_title_client}
                        expanded={sections.cliente}
                        onToggle={() => this.toggleSection('cliente')}
                    >
                        <RespondClienteSection cliente={cliente} currentLanguage={currentLanguage} />
                    </CardSection>

                    <CardSection
                        title={currentLanguage.bepiService.admin.admin_estimate_respond_card_title_estimate}
                        expanded={sections.estimativa}
                        onToggle={() => this.toggleSection('estimativa')}
                    >
                        <RespondEstimateItemsSection
                            estimativa={estimativaAtual}
                            onAbrirModalServicos={this.abrirModalServicos}
                            currentLanguage={currentLanguage}
                        />
                    </CardSection>

                    <CardSection
                        title={currentLanguage.bepiService.admin.admin_estimate_respond_card_title_admin_response}
                        expanded={sections.resposta}
                        onToggle={() => this.toggleSection('resposta')}
                    >
                        <RespondFormSection
                            ref={ref => this.respondFormRef = ref}
                            modo="admin"
                            respostaInicial={respostaData}
                            onRespostaChange={this.handleRespostaChange}
                            onEnviarResposta={this.enviarResposta}
                            currentLanguage={currentLanguage}
                        />
                    </CardSection>

                    <RespondServicosModal
                        open={modalServicosAberto}
                        servicosCache={servicosCache}
                        onFechar={this.fecharModalServicos}
                        onAdicionarItem={this.adicionarItemResposta}
                        currentLanguage={currentLanguage}
                    />
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(AdminEstimateRespondPage);
